function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  -webkit-font-smoothing: antialiased;\n  border: 0;\n  box-sizing: border-box;\n  color: #67798d;\n  flex: 1 1 0%;\n  font-family: SFMono-Regular, Consolas, 'Liberation Mono', Menlo, Courier,\n    monospace;\n  font-size: 12px;\n  font-weight: 400;\n  height: 100%;\n  line-height: 32px;\n  margin: 0;\n  overflow: hidden;\n  padding: 4px 6px 4px 0;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import React from 'react';
import { Form, Switch } from 'antd';
import styled from 'styled-components';
export var StyledFormItem = styled(Form.Item)(_templateObject());

function BooleanInput(_ref) {
  var {
    name,
    checkParameter
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledFormItem, {
    key: name,
    name: [name, 'value'],
    rules: [{
      validator: checkParameter
    }],
    valuePropName: "checked"
  }, /*#__PURE__*/React.createElement(Switch, {
    checkedChildren: "true",
    unCheckedChildren: "false"
  }));
}

export default BooleanInput;